import PollModel from '../components/Modals/PollModel'
import platform from 'platform'

const appMetaData = {
  appId: 'showcase_18882189-2b50-42eb-839c-8bb894744ce9',
  token: '',
  msisdnMain: '',
  msisdnSlave: '',
  operatingSystem: platform.os.family,
  operatingSystemVersion: platform.os.version,
  appVersion: '1.01'
}

const resolveGuestToken = page => String(page?.props?.guest_uuid || '')

export const registerEvent1 = async page => {
  if (page.props?.user === null) {
    return
  }

  if (page.props?.user?.polls_eligible) {
    setTimeout(() => {
      if ( typeof tNPS !== 'undefined' ) {
        tNPS.registerEvent('event_62c573d8-208a-4fa1-96b6-7e921dd4e472')
      } else {
        console.debug( 'tNPS is undefined!' )
      }
    }, 3000)
  }
}
export const registerEvent2 = async page => {
  if ( typeof tNPS !== 'undefined' ) {
    tNPS.registerEvent('event_222ab87b-f6dc-4f9e-bdc3-f5715e391224')
  } else {
    console.debug( 'tNPS is undefined!' )
  }
}
export const registerEvent3 = async page => {
  if (page.props?.user !== null) {
    return
  }

  const guestVisitCount = Number(page.props?.guest_visit_count) || 0

  if (guestVisitCount >= 2) {
    setTimeout(() => {
      if ( typeof tNPS !== 'undefined' ) {
        tNPS.registerEvent('event_349e131a-03b0-4e7b-abe2-79211db9af0a')
      } else {
        console.debug( 'tNPS is undefined!' )
      }
    }, 30000)
  }
}
export const registerEvent4 = async page => {
  if ( typeof tNPS !== 'undefined' ) {
    tNPS.registerEvent('event_897ab168-bd96-4e15-a27d-98b0b7673165')
  } else {
    console.debug( 'tNPS is undefined!' )
  }
}

export const callEvent = async page => {
  await registerEvent1(page)
  await registerEvent3(page)

  if (page.props?.polls_event === undefined) return
  if (page.props.polls_event === null) return
  switch (page.props?.polls_event || '') {
  case 'event_2':
    return await registerEvent2(page)
  case 'event_4':
    return await registerEvent4(page)
  }
}

export const init = async($vueModal, page) => {
  if (!('tNPS' in window)) {
    console.error('[tNPS]', 'Не установлен')

    return false
  }

  appMetaData.token = resolveGuestToken(page)

  if (page.props?.user) {
    try {
      const response = await fetch('/profile/phone', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
      if (response.ok) {
        const data = await response.json()
        appMetaData.msisdnMain = String(data?.phone || '').replace('+', '')
      }
    } catch (error) {
      appMetaData.msisdnMain = ''
    }
  }
  const isMobile = window.innerWidth <= 768

  window.addEventListener('message', e => {
    if (e.data === 'pollPlayerClose') {
      $vueModal.hide('poll-modal')
    }
  })
  const launchPoll = async url => {
    await $vueModal.show(
      PollModel,
      {
        src: url
      },
      {
        name: 'poll-modal',
        clickToClose: true,
        width: 400,
        height: 'auto',
        adaptive: true,
        scrollable: false,
        shiftX: isMobile ? 0.5 : 0.99,
        shiftY: isMobile ? 0.5 : 0.9
      }
    )
  }
  if ( typeof tNPS != 'undefined' ) {
    await tNPS.start(launchPoll, appMetaData)
    await tNPS.showPoll()
  } else {
    console.warn( 'tNPS is not defined, unable to start' )
  }
}
